import type { VideoCategory, VideoCategoryShallow } from "@brookbush/types";

import clsx from "clsx";
import { NextSeo } from "next-seo";

import VideosCard from "./VideosCard";
import CardGrid from "~/components/CardGrid";
import Carousel from "~/components/Carousel";
import Illustration from "~/components/Illustration";
import { getCategoryPathByCategory } from "~/lib/videos.lib";

const VideosCategory = ({
	category,
	shallowCategories,
}: {
	category: VideoCategory;
	shallowCategories: VideoCategoryShallow[];
}) => {
	return (
		<>
			<NextSeo {...category} />

			<div
				className={clsx(
					"flex w-full flex-col gap-4 phablet:gap-6",
					category.videos?.length ? "mt-2" : "mt-2",
				)}
			>
				<h1 className="phablet:text-left text-center font-semibold laptop:text-3xl phablet:text-3xl text-2xl">
					{category.title}
				</h1>

				{category.subCategories?.length ? (
					<div className="flex flex-col gap-4">
						{category.subCategories
							.filter((subCategory) => subCategory.videos?.length)
							.map((subCategory) => {
								const subCategoryPath = getCategoryPathByCategory(
									shallowCategories,
									subCategory,
								);

								return (
									<Carousel
										hasMore
										title={subCategory.title}
										key={subCategory._key}
										href={`/videos/categories/${subCategoryPath
											.map((category) => category.slug)
											.join("/")}`}
									>
										{subCategory.videos?.map((video) => (
											<VideosCard key={video._id} {...video} />
										))}
									</Carousel>
								);
							})}
					</div>
				) : category.videos?.length ? (
					<CardGrid>
						{category.videos?.map((video) => (
							<div className="card-grid-node-basis" key={video._id}>
								<VideosCard {...video} />
							</div>
						))}
					</CardGrid>
				) : (
					<Illustration
						src="/illustrations/empty.svg"
						alt="No videos found"
						title="No Videos Found"
						className="my-28"
					/>
				)}
			</div>
		</>
	);
};

export default VideosCategory;
